var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "entity-main-data" }, [
    _c("div", { staticClass: "item" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Operación")]),
      _c("span", [_vm._v(_vm._s(_vm.transaction.companyOperationId))]),
    ]),
    _c("div", { staticClass: "item" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Fecha")]),
      _c("span", [_vm._v(_vm._s(_vm.transaction.dueDate))]),
    ]),
    _c("div", { staticClass: "item" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Pago Nro.")]),
      _c("span", [_vm._v(_vm._s(_vm.transaction.paymentNumber))]),
    ]),
    _c("div", { staticClass: "item" }, [
      _c("span", { staticClass: "title" }, [_vm._v("Monto")]),
      _c("span", [
        _vm._v(
          "CLP " +
            _vm._s(
              _vm.formatNumber(_vm.transaction.secondaryCurrencyConsignedAmount)
            )
        ),
      ]),
    ]),
    _c("div", { staticClass: "item" }, [
      _vm.transaction.status == "TO_AMEND"
        ? _c(
            "button",
            {
              staticClass: "button is-button-primary is-rounded is-small",
              attrs: {
                id: `enmendar-button-${_vm.transaction.paymentNumber}`,
                "data-cy": `enmendar-button-${_vm.transaction.paymentNumber}`,
                type: "button",
                disabled: _vm.isDisabledEnmendarButton,
              },
              on: {
                click: function ($event) {
                  return _vm.enmendar()
                },
              },
            },
            [
              _c(
                "span",
                {
                  attrs: {
                    "data-cy": `enmendar-span-${_vm.transaction.investorId}`,
                  },
                },
                [_vm._v("Enmendar")]
              ),
            ]
          )
        : _vm._e(),
      _vm.transaction.status == "TO_AMEND_MANUALLY"
        ? _c("span", [_c("strong", [_vm._v("Va a Enmienda Manual")])])
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "error-message",
          attrs: {
            id: "enmendar-error-title",
            "data-cy": "enmendar-error-title",
          },
        },
        [
          _vm.isErrorMessage
            ? _c("span", [_vm._v(_vm._s(_vm.isErrorMessage))])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }